import { ChangeDetectionStrategy, Component, effect, EffectRef, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SubmitGroupComponent, TextComponent } from '@libs/form/components';
import { IconComponent } from '@libs/components/icons';
import { SubmitGroupItemModel, TextInputModel } from '@libs/form/models';
import { CustomerModel } from '@libs/account/models';
import { AliasInputData, SubmitGroupData } from './customer-alias.model';

@Component({
  selector: 'ui-customer-alias',
  templateUrl: './customer-alias.component.html',
  styleUrls: ['./customer-alias.component.scss'],
  imports: [
    ReactiveFormsModule,
    TextComponent,
    SubmitGroupComponent,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerAliasComponent {
  private readonly patchEffect: EffectRef;

  public customer: InputSignal<CustomerModel | undefined> = input<CustomerModel | undefined>();
  public submitResult: OutputEmitterRef<Partial<CustomerModel>> = output<Partial<CustomerModel>>();

  public dataAlias: TextInputModel = AliasInputData;
  public dataSubmit: SubmitGroupItemModel = SubmitGroupData;
  public group: FormGroup = new UntypedFormGroup({
    [this.dataAlias.name]: new UntypedFormControl(),
  });

  public constructor() {
    this.patchEffect = effect(() => {
      const customer: CustomerModel | undefined = this.customer();

      this.group.patchValue({
        [this.dataAlias.name]: customer?.alias ?? '',
      });
    });
  }

  public onSubmit(): void {
    if (this.group.valid) {
      this.submitResult.emit(this.group.value as Partial<CustomerModel>);
    }
  }
}
